export default function IconClock({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M9.2 12.6L10.99 14.33L14.8 9.67M12 22C14.41 20.78 16.1 19.36 17.28 18.02C19.08 15.98 20 13.31 20 10.59V5L12 2L4 5V10.59C4 13.31 4.92 15.98 6.72 18.02C7.91 19.36 9.6 20.78 12 22Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
